import { FlagIcon } from '~/icons';

// standard icon for neutral
declare module '@mui/material/Alert' {
  interface AlertPropsColorOverrides {
    important: true;
  }
}

export const MuiAlert = {
  defaultProps: {
    variant: 'standard',
    iconMapping: {
      important: <FlagIcon />,
    },
  },
  styleOverrides: {
    root: {
      fontSize: '1.6rem',
      padding: '8px 12px',

      '& .MuiAlert-action': {
        padding: '8px',

        '&  svg': {
          width: '10px',
          height: '10px',
        },
      },
      '& .MuiAlert-icon': {
        width: '2.2rem',
        height: '2.2rem',
        padding: '8px 0',
        marginRight: '8px',

        '& svg': {
          width: '2.2rem',
          height: '2.2rem',
        },
      },
      '&.MuiAlert-colorError': {
        backgroundColor: '#FFEFEE',
        borderLeft: '4px solid #E40A1A',

        '& .MuiAlert-icon': {
          color: '#E40A1A',
        },
      },
      '&.MuiAlert-colorWarning': {
        backgroundColor: '#FFF9DB',
        borderLeft: '4px solid #F7A800',
        color: '#000000C4',

        '& .MuiAlert-icon': {
          color: '#F7A800',
        },
      },
      '&.MuiAlert-colorSuccess': {
        backgroundColor: '#EFF9E3',
        borderLeft: '4px solid #59A719',

        '& .MuiAlert-icon': {
          color: '#59A719',
        },
      },
      '&.MuiAlert-colorInfo': {
        backgroundColor: '#E9FAFF',
        borderLeft: '4px solid #008EFF',

        '& .MuiAlert-icon': {
          color: '#008EFF',
        },
      },

      '&.MuiAlert-colorImportant': {
        backgroundColor: '#F8ECFF',
        borderLeft: '4px solid #C121EB',

        '& .MuiAlert-icon': {
          color: '#C121EB',
        },
      },
    },
  },
};
